/**
 * Condições dos tokens da cena (BRAZ-25, docs/spec/table-media.md): Cego, Morto, Envenenado etc.
 * Nesta versão são só visuais (um ícone no token); quem as aplica é o mestre, em qualquer token,
 * e quem controla o token, no dele. Cada condição é um atributo `cond_<id>` do nó do token (true
 * ou ausente), e os ids não mudam: as fichas poderão ler a lista e saber quando ela muda. O
 * Invisível (`sceneInvisible.ts`) usa o mesmo prefixo, mas tem mecânica própria.
 */

/** As condições, na ordem do menu. */
export const TOKEN_CONDITIONS = ['blind', 'dead', 'poisoned', 'stunned', 'paralyzed', 'prone', 'frightened', 'unconscious', 'bleeding'] as const;
export type TokenCondition = (typeof TOKEN_CONDITIONS)[number];

/** O atributo da condição no nó do token. */
export const conditionAttr = (id: TokenCondition) => `cond_${id}`;

/** As condições ligadas, na ordem da lista (`get` lê um atributo do token). */
export const readConditions = (get: (name: string) => unknown): TokenCondition[] => TOKEN_CONDITIONS.filter((id) => get(conditionAttr(id)) === true);
